module.exports = __webpack_public_path__ + "9fdc97486fa07bba20b3bb505ab0e693.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/dominik-kundel.jpg
// module id = 513
// module chunks = 0